import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

const currenciesApi = createApi({
    reducerPath: 'api.currencies',
    baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL }),
    tagTypes: ['currencies'],
    endpoints: (builder) => ({
        getCurrencies: builder.query<any, void>({
            query: () => ({
                url: `/currencies`, // GET simple
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
        }),
    }),
});

export const { useGetCurrenciesQuery } = currenciesApi;
export default currenciesApi;
